import {
  ARENA_TABLE_HEADER,
  ARENA_TABLE_ORDERED_COLUMNS
} from '@bo-constants/arenaContest';
import { Table, TableBody, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { MemberEntryModalArenaTableRow } from '@library/components/modals/MemberEntryModal/MemberEntryModalArenaTableRow';
import { formatArenaContestDataForTable } from '@bo-utils/arenaContest';
import { useArenaContest } from '@bo-hooks/arenaContest/useArenaContest';
import { useMemo } from 'react';

export interface MemberEntryModalArenaTableProps {
  selectedNewWagerContestId: string;
  entryId: string | undefined;
}

export const MemberEntryModalArenaTable = ({
  selectedNewWagerContestId,
  entryId
}: MemberEntryModalArenaTableProps) => {
  const {
    data: arenaContestData,
    isError,
    isFetching
  } = useArenaContest({
    contestId: selectedNewWagerContestId
  });

  const formattedData = useMemo(
    () => arenaContestData?.map(formatArenaContestDataForTable),
    [arenaContestData]
  );

  if (isFetching) {
    return <Loading loadingMessage="" />;
  }

  if (isError) {
    return (
      <section className="p-6">
        <h1 className="text-soClean-100 m-auto text-xl font-bold">
          Error Fetching Arena Contest Data
        </h1>
      </section>
    );
  }

  return (
    <Table className="border-soFresh-140 no-scrollbar w-full overflow-x-auto rounded-md border p-0">
      <TableHeader
        className="bg-soFresh-120 text-soClean-180 z-10 text-sm font-semibold"
        buttonClassName="text-center justify-center flex"
        headers={ARENA_TABLE_HEADER}
      />
      <TableBody>
        {formattedData?.map((formattedTableEntry) => (
          <MemberEntryModalArenaTableRow
            rowData={formattedTableEntry}
            columns={ARENA_TABLE_ORDERED_COLUMNS}
            key={formattedTableEntry.memberId}
            entryId={entryId}
          />
        ))}
      </TableBody>
    </Table>
  );
};
